<div class="clean-payment-container">
  <div class="card-payment-container">
    <div class="document-details">
      <h2>{{ 'PAYMENT.PURCHASE_DOCUMENT' | translate }}</h2>

      <!-- Loading Indicator -->
      <div *ngIf="isLoading" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="loading-text">{{ 'PAYMENT.DOCUMENT_LOADING_INFO' | translate }}</p>
      </div>

      <!-- Existing Document Section -->
      <div class="existing-document-notice" *ngIf="existingRequest && !isLoading">
        <div class="success-message">
          <mat-icon>check_circle</mat-icon>
          <span>{{ 'PAYMENT.PURCHASE_DOCUMENT_SUCCESS' | translate }}</span>
        </div>
        <div class="document-info">
          <p><strong>{{ 'PAYMENT.TYPE_OF_DOCUMENT' | translate }}:</strong> {{ documentType }}</p>
          <p><strong>{{ 'PAYMENT.FORMAT_OF_DOCUMENT' | translate }}:</strong> {{ documentFormat }}</p>
          <p *ngIf="documentPrice > 0"><strong>{{ 'PAYMENT.PRICE_OF_DOCUMENT' | translate }}:</strong> {{ documentPrice
            }} RON</p>
          <p><strong>{{ 'PAYMENT.STATUS_OF_DOCUMENT' | translate }}:</strong> <span
              style="color: #2e7d32">{{ 'PAYMENT.PURCHASED' | translate }}</span></p>
        </div>
      </div>

      <!-- Payment Section -->
      <div class="payment-section" *ngIf="!existingRequest && !isLoading">
        <div class="price-details">
          <span class="price" *ngIf="documentPrice > 0">{{ documentPrice }}</span>
          <span class="price free-price" *ngIf="documentPrice == 0">{{ 'PAYMENT.FREE' | translate }}</span>
          <div class="document-description">{{ documentType }} - {{ documentFormat }}</div>
        </div>

        <div class="document-info">
          <p><strong>{{ 'PAYMENT.TYPE_OF_DOCUMENT' | translate }}:</strong> {{ documentType }}</p>
          <p><strong>{{ 'PAYMENT.FORMAT_OF_DOCUMENT' | translate }}:</strong> {{ documentFormat }}</p>
          <p *ngIf="documentPrice > 0"><strong>{{ 'PAYMENT.PRICE_OF_DOCUMENT' | translate }}:</strong> {{ documentPrice
            }} RON</p>
          <p><strong>{{ 'PAYMENT.STATUS_OF_DOCUMENT' | translate }}:</strong> <span style="color: #ff6f00">{{
              'PAYMENT.WAITING_FOR_PAYMENT' | translate }}</span></p>
        </div>

        <div class="payment-notes">
          <mat-icon>info</mat-icon>
          <p *ngIf="documentPrice > 0">{{ 'PAYMENT.DOCUMENT_PAYMENT_TYPE_ONE' | translate }}</p>
          <p *ngIf="documentPrice == 0">{{ 'PAYMENT.DOCUMENT_PAYMENT_TYPE_TWO' | translate }}</p>
        </div>
      </div>
    </div>

    <!-- Actions Section -->
    <div class="actions" *ngIf="showButtons">
      <!-- Download Button - Show if free or existing doc -->
      <button *ngIf="(existingRequest || documentPrice == 0) && !isLoading" mat-raised-button color="accent"
        (click)="initiatePayment()">
        <span>
          <mat-icon>download</mat-icon>
          {{ 'PAYMENT.DOWNLOAD_FREE' | translate }}
        </span>
      </button>

      <!-- Loading Button -->
      <button *ngIf="isLoading" mat-raised-button color="accent" disabled>
        <mat-spinner diameter="24"></mat-spinner>
      </button>

      <!-- Pay Button - Show for paid docs that aren't purchased yet -->
      <button *ngIf="!existingRequest && documentPrice != 0 && !isLoading" mat-raised-button color="primary"
        (click)="initiatePayment()">
        <span>
          <mat-icon>payment</mat-icon>
          {{ 'PAYMENT.PAY_WITH_STRIPE' | translate }}
        </span>
      </button>

      <!-- Back Button - Always visible -->
      <button mat-stroked-button (click)="goBack()">
        <span>
          <mat-icon>arrow_back</mat-icon>
          {{ 'PAYMENT.BACK_TO_DOCUMENTS' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>